import { exportMultipleElementsToPDF } from "@perfectserve/library";
export const exportInteractionCardsToPDF = async (options) => {
    var _a, _b;
    const { selectedAccounts, selectedUsers, onProgress, signal } = options;
    const cardElements = document.querySelectorAll(".interactions-summary-card");
    if (cardElements.length === 0) {
        throw new Error("No cards found to export");
    }
    const elements = Array.from(cardElements);
    let filename = "Interactions_Dashboard";
    if (selectedAccounts.length === 1) {
        filename = `${((_a = selectedAccounts[0]) === null || _a === void 0 ? void 0 : _a.name) || "Account"}_Interactions`;
    }
    else if (selectedUsers.length === 1) {
        filename = `${((_b = selectedUsers[0]) === null || _b === void 0 ? void 0 : _b.displayName) || "User"}_Interactions`;
    }
    else if (selectedAccounts.length > 1 || selectedUsers.length > 1) {
        filename = "Multiple_Accounts_Interactions";
    }
    await exportMultipleElementsToPDF({
        filename,
        elements,
        orientation: "landscape",
        format: "a4",
        quality: 0.95,
        scale: 2,
        margins: { top: 15, right: 15, bottom: 15, left: 15 },
        onProgress,
        ...(signal && { signal }),
    });
};
//# sourceMappingURL=pdfExportUtils.js.map